import { BreadcrumbsCC, ContainerPage } from 'components/Layout'
import React, { useEffect } from 'react'
import TableManageVersion from '../components/TableManageVersion'
import SearchPage from 'components/Layout/SearchPage'
import { useDispatch, useSelector } from 'react-redux'
import { getManagerVersionState } from '../store/functions'
import { SearchCC } from 'components/common/SearchCC'
import { fetchDataVersion, setSearchQuery } from '../store/managerVerionSlice'
import { Box, Button, useMediaQuery } from '@mui/material'
import { IconCircleAdd, IconEditUser } from 'components/common/IconCommon'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import apiAppVersions from 'api/app-verisons'
import { toastError } from 'utils/helpers'
import theme from 'theme'

const ListVersion = () => {

    const dispatch = useDispatch()
    const { t } = useTranslation()
    const navigate = useNavigate()
    const matches = useMediaQuery(theme.breakpoints.up('md'));
    const isSM = useMediaQuery(theme.breakpoints.up('sm'));

    const { searchQuery, tableData } = useSelector((state) => getManagerVersionState(state))

    const handleChangeSearchVersion = (value) => {
        dispatch(setSearchQuery({
            version: value
        }))
    }

    const handleSearch = () => {
        fetchDataVersion()
    }

    const setPage = (value) => {
        dispatch(setSearchQuery({
            page: value
        }))
    }

    const handleCreateVersion = () => navigate('create')
    const handleUpdateCurrentVersion = async () => {
        try {
            const res = await apiAppVersions.get({ id: 'current' })
            if(res?.data) {
                navigate(`update/${res.data.id}`)
            } else {
                toastError(t('toast.noActiveVersion'))
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        fetchDataVersion()
    }, [searchQuery.page])

    return (
        <ContainerPage sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
            <BreadcrumbsCC />
            <SearchPage>
                <div></div>
                {/* Tìm kiếm theo phiên bản */}
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 3 }}>
                    {isSM && <SearchCC
                        value={searchQuery?.version}
                        setValue={handleChangeSearchVersion}
                        handleValue={() => handleSearch()}
                        placeholder='placeholder.enterVersion'
                        maxLength={300}
                        id="search-version" />}
                    <Button id='btn-edit-current-version' variant='outlined' startIcon={<IconEditUser />} onClick={handleUpdateCurrentVersion}>{matches && t('actions.editCurrentVersion')}</Button>
                    <Button id='btn-add-version' startIcon={<IconCircleAdd />} onClick={handleCreateVersion}>{matches && t('actions.addVersion')}</Button>
                </Box>
            </SearchPage>
            <TableManageVersion tableData={tableData} page={searchQuery.page} size={5} setPage={setPage}/>
        </ContainerPage>
    )
}

export default ListVersion